
(function () {
  const ITEM_SELECTOR = '.hdt-list-categories .hdt-categories-list > .hdt-menu-item';
  const LEVEL2_ITEM_SELECTOR = '.hdt-list-categories .hdt-sub-menu-lever-1 > li';
  const VIEWPORT_PAD = 12;

  function shouldAlignItem(item) {
    const menu = item.querySelector('hdt-header-menu');
    const fixPos = menu?.getAttribute('fix-position') || 'item';
    return fixPos !== 'center' && fixPos !== 'end';
  }

  function getViewportBounds() {
    const headerH = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    const top = (Number.isFinite(headerH) ? headerH : 0) + VIEWPORT_PAD;
    return {
      top,
      bottom: window.innerHeight - VIEWPORT_PAD,
    };
  }

  function measureFlyoutHeight(flyout) {
    const rectH = flyout.getBoundingClientRect().height;
    if (rectH > 0) return rectH;
    const scrollH = flyout.scrollHeight;
    if (scrollH > 0) return scrollH;
    return 0;
  }

  function applyFlyoutTop(flyout, targetTop) {
    const flyoutCs = getComputedStyle(flyout);

    if (flyoutCs.position === 'fixed') {
      flyout.style.setProperty('top', `${targetTop}px`, 'important');
    } else {
      const offsetParent = flyout.offsetParent;
      const baseTop = offsetParent ? offsetParent.getBoundingClientRect().top : 0;
      flyout.style.setProperty('top', `${targetTop - baseTop}px`, 'important');
    }

    flyout.style.setProperty('transform', 'none', 'important');
    flyout.style.setProperty('bottom', 'auto', 'important');
  }

  function clearCaches() {
    document.querySelectorAll('[data-dth-base-height]').forEach(el => {
      el.removeAttribute('data-dth-base-height');
    });
    document.querySelectorAll('[data-dth-level3-base-height]').forEach(el => {
      el.removeAttribute('data-dth-level3-base-height');
    });
  }

  function alignCategorySubmenu(item) {
    if (!shouldAlignItem(item)) return;

    const details =
      item.querySelector(':scope > hdt-header-menu > details') || item.querySelector(':scope > details');
    if (!details) return;

    const summary = details.querySelector('summary');
    const flyout = details.querySelector(':scope > .hdt-sub-menu, :scope > .hdt-mega-menu');
    if (!summary || !flyout) return;

    const summaryRect = summary.getBoundingClientRect();
    const bounds = getViewportBounds();
    const maxAvailableHeight = bounds.bottom - bounds.top;

    let flyoutHeight = parseFloat(flyout.dataset.dthBaseHeight);
    if (!flyoutHeight) {
      flyout.style.removeProperty('max-height');
      flyout.style.removeProperty('overflow-y');
      flyoutHeight = measureFlyoutHeight(flyout);
      if (flyoutHeight > 0) {
        flyout.dataset.dthBaseHeight = flyoutHeight;
      }
    }

    if (!flyoutHeight) return;

    if (flyoutHeight > maxAvailableHeight) {
      flyoutHeight = maxAvailableHeight;
      flyout.style.setProperty('max-height', `${maxAvailableHeight}px`, 'important');
      flyout.style.setProperty('overflow-y', 'auto', 'important');
    } else {
      flyout.style.removeProperty('max-height');
      flyout.style.removeProperty('overflow-y');
    }

    let targetTop = summaryRect.top;

    if (summaryRect.top + flyoutHeight > bounds.bottom) {
      targetTop = bounds.bottom - flyoutHeight;
    }

    if (targetTop < bounds.top) {
      targetTop = bounds.top;
    }
    if (targetTop + flyoutHeight > bounds.bottom) {
      targetTop = bounds.bottom - flyoutHeight;
    }

    applyFlyoutTop(flyout, targetTop);
    flyout.dataset.dthAlignTail = summaryRect.top + flyoutHeight > bounds.bottom ? '1' : '0';
  }

  function alignLevel3Submenu(li) {
    const details = li.querySelector('details');
    if (!details) return;

    const summary = details.querySelector('summary');
    const flyout = details.querySelector(':scope > .hdt-sub-menu-child');
    if (!summary || !flyout) return;

    const level2Dropdown = li.closest('.hdt-dropdown-menu');
    if (!level2Dropdown) return;

    const level2DropdownRect = level2Dropdown.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();
    const bounds = getViewportBounds();

    const minTop = level2DropdownRect.top;
    const maxAvailableHeight = bounds.bottom - minTop;

    let flyoutHeight = parseFloat(flyout.dataset.dthLevel3BaseHeight);
    if (!flyoutHeight) {
      flyout.style.removeProperty('max-height');
      flyout.style.removeProperty('overflow-y');
      flyoutHeight = measureFlyoutHeight(flyout);
      if (flyoutHeight > 0) {
        flyout.dataset.dthLevel3BaseHeight = flyoutHeight;
      }
    }

    if (!flyoutHeight) return;

    if (flyoutHeight > maxAvailableHeight) {
      flyoutHeight = maxAvailableHeight;
      flyout.style.setProperty('max-height', `${maxAvailableHeight}px`, 'important');
      flyout.style.setProperty('overflow-y', 'auto', 'important');
    } else {
      flyout.style.removeProperty('max-height');
      flyout.style.removeProperty('overflow-y');
    }

    let targetTop = summaryRect.top;

    if (summaryRect.top + flyoutHeight > bounds.bottom) {
      targetTop = bounds.bottom - flyoutHeight;
    }

    if (targetTop < minTop) {
      targetTop = minTop;
    }
    if (targetTop + flyoutHeight > bounds.bottom) {
      targetTop = bounds.bottom - flyoutHeight;
    }

    applyFlyoutTop(flyout, targetTop);
  }

  function scheduleAlign(item) {
    alignCategorySubmenu(item);
    requestAnimationFrame(() => alignCategorySubmenu(item));
    [16, 50, 120, 250, 400].forEach((ms) => {
      setTimeout(() => {
        if (item.matches(':hover') || item.querySelector('details[open]')) {
          alignCategorySubmenu(item);
        }
      }, ms);
    });
  }

  function scheduleAlignLevel3(li) {
    alignLevel3Submenu(li);
    requestAnimationFrame(() => alignLevel3Submenu(li));
    [16, 50, 120, 250, 400].forEach((ms) => {
      setTimeout(() => {
        if (li.matches(':hover') || li.querySelector('details[open]')) {
          alignLevel3Submenu(li);
        }
      }, ms);
    });
  }

  function bindItem(item) {
    if (item.dataset.dthCatSubAlign) return;
    item.dataset.dthCatSubAlign = '1';

    item.addEventListener('mouseenter', () => scheduleAlign(item));
    item.addEventListener('focusin', () => scheduleAlign(item));

    const details = item.querySelector('details');
    details?.addEventListener('toggle', () => {
      if (!details.open) {
        const flyout = details.querySelector(':scope > .hdt-sub-menu, :scope > .hdt-mega-menu');
        if (flyout) flyout.removeAttribute('data-dth-base-height');
      }
      scheduleAlign(item);
    });

    const menu = item.querySelector('hdt-header-menu');
    menu?.addEventListener('mouseenter', () => scheduleAlign(item));

    const flyout = details?.querySelector(':scope > .hdt-sub-menu, :scope > .hdt-mega-menu');
    if (flyout && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => {
        if (item.matches(':hover') || item.querySelector('details[open]')) {
          alignCategorySubmenu(item);
        }
      });
      ro.observe(flyout);
    }
  }

  function bindLevel2Item(li) {
    if (li.dataset.dthLevel3Align) return;
    li.dataset.dthLevel3Align = '1';

    li.addEventListener('mouseenter', () => scheduleAlignLevel3(li));
    li.addEventListener('focusin', () => scheduleAlignLevel3(li));

    const details = li.querySelector('details');
    details?.addEventListener('toggle', () => {
      if (!details.open) {
        const flyout = details.querySelector(':scope > .hdt-sub-menu-child');
        if (flyout) flyout.removeAttribute('data-dth-level3-base-height');
      }
      scheduleAlignLevel3(li);
    });

    const flyout = details?.querySelector(':scope > .hdt-sub-menu-child');
    if (flyout && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => {
        if (li.matches(':hover') || li.querySelector('details[open]')) {
          alignLevel3Submenu(li);
        }
      });
      ro.observe(flyout);
    }
  }

  function alignHovered() {
    document.querySelectorAll(`${ITEM_SELECTOR}:hover`).forEach(scheduleAlign);
    document.querySelectorAll(`${LEVEL2_ITEM_SELECTOR}:hover`).forEach(scheduleAlignLevel3);
  }

  function init() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(bindItem);
    document.querySelectorAll(LEVEL2_ITEM_SELECTOR).forEach(bindLevel2Item);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', () => {
    clearCaches();
    alignHovered();
  }, { passive: true });
  window.addEventListener('scroll', alignHovered, { passive: true });
})();
